import * as React from "react";

interface TelegramIconProps {
	iconColor: string;
	style: any;
	onClick?: () => void;
}

const TelegramIcon = (props: TelegramIconProps) => (
	<svg
		width="38px"
		height="38px"
		viewBox="0 0 45 45"
		version="1.1"
		style={props.style}
		onClick={props.onClick}
	>
		<g
			id="1440x-1024"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			transform="translate(-779.000000, -922.000000)"
		>
			<g
				id="Social-Media-Icons"
				transform="translate(518.000000, 922.000000)"
				fill={props.iconColor}
				fillRule="nonzero"
			>
				<path
					d="M261.961133,21.2655109 L273.698177,25.6461451 L278.241132,40.2562394 C278.531816,41.1919632 279.676045,41.5378295 280.435524,40.9169001 L286.977951,35.5833931 C287.663741,35.0246075 288.640554,34.9967616 289.357246,35.5170044 L301.157452,44.0842005 C301.969907,44.6747372 303.120927,44.2295425 303.324678,43.247805 L311.968959,1.66726655 C312.191387,0.594860125 311.137658,-0.299774048 310.116528,0.0951621992 L261.94738,18.6773711 C260.758666,19.1358095 260.769024,20.8187881 261.961133,21.2655109 Z M277.508989,23.3142214 L300.447552,9.18633652 C300.859807,8.93317662 301.283947,9.49060383 300.929931,9.8189816 L281.998969,27.4162269 C281.333554,28.0356282 280.90432,28.8645529 280.782749,29.7642808 L280.137879,34.5432471 C280.052474,35.1813256 279.156141,35.244658 278.980067,34.6271244 L276.499915,25.9125488 C276.215853,24.9185863 276.629806,23.8568767 277.508989,23.3142214 Z"
					id="XMLID_497_"
				/>
			</g>
		</g>
	</svg>
);

export default TelegramIcon;



// WEBPACK FOOTER //
// ./src/components/Footer/TelegramIcon.tsx